module.exports = __webpack_public_path__ + "img/GH-kyujin-top-h-pa-3.8ccf08ce.webp";